<ng-container *transloco="let tloco; prefix: 'subscriptions.payment-methods'">
  <mat-dialog-content class="block w-full">
    <h1 class="text-heading-2" mat-dialog-title>{{ tloco('finalise') }}</h1>

    @if (setupIntent$ | async; as setupIntent) {
      {{ tloco('status') + setupIntent.status }}
    } @else {
      @if (error$ | async; as error) {
        <mat-error>{{ error }}</mat-error>
      } @else {
        <mat-spinner class="-mr-1 ml-2" />
      }
    }
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <button type="button" mat-button color="primary" mat-dialog-close>{{ 'action.close' | transloco }}</button>
  </mat-dialog-actions>
</ng-container>
